// extracted by mini-css-extract-plugin
export default {"container":"WG-z","contactUsLink":"XG-z"};